import { Box } from '@mui/material';
import { Link } from 'react-router-dom-v5-compat';
import classNames from 'classnames';
import { pages } from 'common';

import classes from './Logo.module.scss';

type LogoProps = {
  className?: string;
  logoUrl: string | null;
  imgAlt: string | null;
  url?: string;
  size?: number;
};

export const Logo = ({
  className,
  logoUrl,
  imgAlt,
  url = pages.home.path,
  size = 32,
}: LogoProps) => {
  const logoClassName = classNames('app-logo', classes.appLogo, className);

  return (
    logoUrl && (
      <Box className={classes.logo} style={{ height: size }}>
        <Link to={url}>
          <img
            className={`${logoClassName} h-8`}
            src={logoUrl}
            alt={imgAlt ?? 'logo'}
            height={size}
          />
        </Link>
      </Box>
    )
  );
};
